import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VideoSearchResultListPaginated, VideoSearchResult } from '../../model/video-search-result.model';
import { VideoCardComponent } from '../video-card/video-card.component';
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";

@Component({
  selector: 'app-video-grid',
  templateUrl: './video-grid.component.html',
  styleUrls: ['./video-grid.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    VideoCardComponent,
    MatPaginatorModule
  ]
})
export class VideoGridComponent implements OnChanges {
  // TODO: Migrar a signals.
  @Input() videoSearchResultListPaginated: VideoSearchResultListPaginated = null;
  @Input() isInternalUser: boolean = false;
  @Input() pageSize: number = 12;
  @Input() viewMode: 'grid' | 'list' = 'grid';

  @Output() videoDeleted = new EventEmitter<void>();
  @Output() pageChange = new EventEmitter<number>();

  protected displayedVideoSearchResultListPaginated: VideoSearchResultListPaginated = null;
  protected skeletonVideoSearchResultListPaginated: VideoSearchResultListPaginated = null;

  constructor(private router: Router) {
    this.skeletonVideoSearchResultListPaginated = {
      videos: Array(this.pageSize).fill(null),
      current_page: 0,
      has_next_page: false,
      has_previous_page: false,
      num_pages: 1,
      total_items: 0,
    };
    this.displayedVideoSearchResultListPaginated = this.skeletonVideoSearchResultListPaginated;
  }

  ngOnChanges() {
    this.refreshVideoList();
  }

  onCardVideoDeleted() {
    this.videoDeleted.emit();
  }

  onPageEvent(e: PageEvent) {
    this.pageChange.emit(e.pageIndex);
  }

  onVideoClick(video: VideoSearchResult | null) {
    if (!video) return;
    this.router.navigate(['/watch', video.id], { state: { video } });
  }

  private async refreshVideoList() {

    // If the videoSearchResultListPaginated is null, we keep the skeleton
    if (!this.videoSearchResultListPaginated) {
      this.displayedVideoSearchResultListPaginated = this.skeletonVideoSearchResultListPaginated;
    } else {
      this.displayedVideoSearchResultListPaginated = this.videoSearchResultListPaginated;
    }
  }

}
